import { Component, OnInit } from '@angular/core';
import { FireAssessmentService } from 'src/app/services/fire-assessment.service';
import { ActivatedRoute, Router } from "@angular/router"; // ActivatedRoue is used to get the current associated components information.
import { Location } from '@angular/common';  // Location service is used to go back to previous component

@Component({
  selector: 'app-pillars',
  templateUrl: './pillars.component.html',
  styleUrls: ['./pillars.component.scss']
})
export class PillarsComponent implements OnInit {
  public data =[];
  constructor(
    public fireAssessment: FireAssessmentService,
    private router: Router,
    private location: Location,
    private actRoute: ActivatedRoute,
  ) { }


  goBack() {
    this.location.back();
  }
  ngOnInit(): void {
    const id = this.actRoute.snapshot.paramMap.get('id');// Getting current component's id or information using ActivatedRoute service
    this.fireAssessment.ReadAssessment(id).valueChanges().subscribe(data=>{
      this.data = data
      console.log( data);
       //console.log(this.busName)
       //this.assessmentForm.setValue(data) // Using SetValue() method, It's a ReactiveForm's API to store intial value of reactive form 
     });
  }

}
